import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'

export default function Meta(props) {
    const [meta,setMeta] = useState();
    useEffect(() => {
        async function datafunction() {
          await axios.get(process.env.REACT_APP_API + 'api/meta/'+props.id)
            .then((response) => {
                setMeta(response.data.result);
            });
        }
        datafunction();
      }, [props.id]);
  return (
    <>
      <Helmet>
        <title>{meta ? meta.meta_title : '' }</title>
        <meta name="description" content={meta ? meta.meta_description : '' } />
        <meta name="keywords" content={meta ? meta.meta_keywords : '' } />
        <link rel="canonical" href={'https://www.pesinstallations.com' + window.location.pathname} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="PES Installations Limited" />
        <meta property="og:url" content={'https://www.pesinstallations.com' + window.location.pathname} />
        <meta property="og:title" content={meta ? meta.meta_title : '' } />
        <meta property="og:description" content={meta ? meta.meta_description : '' } />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={meta ? meta.meta_title : '' } />
        <meta name="twitter:description" content={meta ? meta.meta_description : '' } />
      </Helmet>
    </>
  )
}
